module.exports = __webpack_public_path__ + "img/rz.61335cf9.png";